// extracted by mini-css-extract-plugin
export default {"terms":"static_terms__ZEqxS","privacy":"static_privacy__fEeDB","tokutei":"static_tokutei__OghaV","requirements":"static_requirements__nRIXj"};